<template>
  <div class="content1">
    <div class="query_con">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="徽章类型">
          <el-select
            v-model="query.cardType"
            placeholder="请选择徽章类型"
            style="width: 100px"
            clearable
            @change="queryData"
          >
            <el-option
              v-for="item in optionsType"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赠送时间">
          <el-date-picker
            v-model="medalDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 210px"
            @change="queryData"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="收卡人工号">
          <el-input
            v-model="query.receiverEmpno"
            placeholder="请输入收卡人工号"
            style="width: 110px"
            clearable
            @change="queryData"
          ></el-input>
        </el-form-item>
        <el-form-item label="发卡人工号">
          <el-input
            v-model="query.senderEmpno"
            placeholder="请输入发卡人工号"
            style="width: 110px"
            clearable
            @change="queryData"
          ></el-input>
        </el-form-item>
        <el-form-item label="收卡人一级部门">
          <el-select
            v-model="query.departmentCode"
            placeholder="请选择收卡人一级部门"
            style="width: 150px"
            clearable
            @change="queryData"
          >
            <el-option
              v-for="item in optionsParentDept"
              :key="item.departmentCode"
              :label="item.departmentName"
              :value="item.departmentCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐状态">
          <el-select
            v-model="query.likeStatus"
            placeholder="推荐状态"
            style="width: 150px"
            clearable
          >
            <el-option label="点赞" :value="1" ></el-option>
            <el-option label="未点赞" :value="0" ></el-option>

          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="add" @click="queryParams">查询</el-button>
          <el-button class="add" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          min-width="60"
        >
        </el-table-column>
        <el-table-column
          prop="medalName"
          label="徽章名称"
          align="center"
          min-width="100"
        >
        </el-table-column>

        <el-table-column
          prop="cardTypeName"
          label="徽章类型"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="point"
          label="积分"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="赠送时间"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="deptName"
          label="一级部门"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sendRtitle"
          label="职级"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sendPosition"
          label="岗位"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sendername"
          label="发卡人"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="senderEmpno"
          label="发卡人工号"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="receivername"
          label="收卡人"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="receiverEmpno"
          label="收卡人工号"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="rtitle"
          label="职级"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="position"
          label="职位"
          align="center"
          min-width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="parentDeptName"
          label="收卡人一级部门"
          align="center"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="ccers"
          label="抄送人"
          align="center"
          show-overflow-tooltip
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div>{{ row.ccers?.toString() }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="reason"
          label="描述"
          align="center"
          min-width="200"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="100"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <i 
              class="el-icon-thumb" 
              style="font-size: 18px; cursor: pointer;"
              :style="{ color: row.likeStatus == 1 ? '#FF4E4E' : '#999' }"
              @click="handleLike(row)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <Export ref="exportDialog" :getSearchList="queryData"></Export>
  </div>
</template>

<script>
import api from "@/apis/medal";
import Export from "../exportFile/export.vue";
import { downloadExcel } from "@/utils/tools";
import moment from "moment";
export default {
  name: "badgeMaintain",
  components: {
    Export
  },
  data() {
    return {
      query: {
        cardType: "",
        receiverEmpno: "",
        senderEmpno: "",
        departmentCode:''
      },
      medalDate: "",
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      windowHeight: 350,
      isShowRecord: 1,
      optionsType: [],
      optionsParentDept: []
    };
  },
  mounted() {
    this.upload = api.upload;
    this.imgUrl = api.imgUrl;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.querydirectory();
    this.queryData();
    this.queryType();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 300;
      });
    },
    queryParams() {
      this.queryData();
    },

    // 点赞 / 取消点赞
    async handleLike(row) {
      try {
        // 切换状态：1→0，0→1
        const newStatus = row.likeStatus == 1 ? 0 : 1;
        
        // 调用接口
        await api.giveLike({
          id: row.id,
          likeStatus: newStatus
        });

        // 前端立即更新状态
        row.likeStatus = newStatus;
        this.$message.success(newStatus == 1 ? "点赞成功" : "取消点赞");
        this.queryData();
      } catch (err) {
        this.$message.error("操作失败");
        console.error(err);
      }
    },

    handleExport() {
      const json = {
        ...this.pageData,
        ...this.query,
        startTime: this.medalDate
          ? moment(this.medalDate[0]).format("YYYY-MM-DD")
          : "",
        endTime: this.medalDate
          ? moment(this.medalDate[1]).format("YYYY-MM-DD")
          : "",
        username: this.$store.state.userInfo.username
      };
      api.excelReportMedal(json).then(data => {
        downloadExcel(data, "徽章发送记录", "xlsx");
        this.$message.success("导出成功!");
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange1(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    handleCurrentChange1(val) {
      this.pageData.page = val;
      this.queryData();
    },
    queryData() {
      const json = {
        ...this.pageData,
        ...this.query,
        startTime:
          this.medalDate?.length > 0
            ? moment(this.medalDate[0]).format("YYYY-MM-DD")
            : "",
        endTime:
          this.medalDate?.length > 0
            ? moment(this.medalDate[1]).format("YYYY-MM-DD")
            : "",
        username: this.$store.state.userInfo.username
      };
      this.tableLoading = true;
      api
        .queryMedalList(json)
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    queryType() {
      api.queryByType({ type: "cardType" }).then(res => {
        if (res.code == 200) {
          this.optionsType = res.data;
          this.optionsType.unshift({
            key: "",
            value: "全部"
          });
        }
      });
    },
    querydirectory() {
      api.findListByName().then(data => {
        if (data.code == 200) {
          this.optionsParentDept = data.data.map(item => item.child)[0];
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content1 {
  background-color: #f2fcf9;

  .query_con {
    padding: 40px 0 0px 40px;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
</style>